module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-196.0ace377.woff2";